import clsx from 'clsx'
import React, { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { BillingColumns } from './BillingColumns'
import { DescriptionMode } from './DescriptionMode'

interface IDetailsContainerProps {
  title?: string | ReactElement
  children: React.ReactNode
  className?: string
  footer?: boolean
  columns: BillingColumns[]
  descriptionMode: DescriptionMode
  showAdjustments?: boolean
  emptyDate?: boolean
  isModal?: boolean
  displayHeader?: boolean
}

const DetailsContainer = ({
  title,
  children,
  className,
  columns = [],
  descriptionMode,
  showAdjustments = false,
  emptyDate = false,
  isModal = false,
  displayHeader = true,
}: IDetailsContainerProps) => {
  const descriptionFlexSize =
    (emptyDate ? 2 : 0) + (columns.includes(BillingColumns.unit) ? 7 : 10)

  return (
    <div className={clsx(s.container, className)}>
      {displayHeader && (
        <div className={s.header}>
          <div
            className={clsx(s.billingTableDetails, {
              [s.descriptionModeToggable]:
                descriptionMode === DescriptionMode.toggable,
              [s.adjustmentMode]: showAdjustments,
              [s.billingTableDetailsModal]: isModal,
            })}
          >
            {columns.includes(BillingColumns.date) && !title && (
              <span className={s.date}>DATE</span>
            )}
            {columns.includes(BillingColumns.description) && (
              <span
                className={clsx({ [s.hideName]: title == null }, s.name)}
                style={{ flex: `${descriptionFlexSize} 1` }}
              >
                <div className={s.title}>{title}</div>
              </span>
            )}
            {columns.includes(BillingColumns.ownerFeesRate) && (
              <span className={clsx(s.vat, s.columnTitle)}>
                <FormattedMessage
                  id='ui.DetailsContainer.comHT'
                  defaultMessage='COM HT'
                />
              </span>
            )}
            {columns.includes(BillingColumns.unit) && (
              <span className={clsx(s.price, s.columnTitle)}>
                <FormattedMessage
                  id='ui.DetailsContainer.unit'
                  defaultMessage='UNITÉ'
                />
              </span>
            )}
            {columns.includes(BillingColumns.quantity) && (
              <span className={clsx(s.quantity, s.columnTitle)}>
                <FormattedMessage
                  id='ui.DetailsContainer.quantity'
                  defaultMessage='QU'
                />
              </span>
            )}
            {columns.includes(BillingColumns.unitHT) && (
              <span className={clsx(s.price, s.columnTitle)}>
                <FormattedMessage
                  id='ui.DetailsContainer.priceHT'
                  defaultMessage='PRIX HT'
                />
              </span>
            )}
            {columns.includes(BillingColumns.totalHT) && (
              <span className={clsx(s.price, s.columnTitle)}>
                <FormattedMessage
                  id='ui.DetailsContainer.totalHT'
                  defaultMessage='TOTAL HT'
                />
              </span>
            )}
            {columns.includes(BillingColumns.vatRate) && (
              <span className={clsx(s.vat, s.columnTitle)}>
                <FormattedMessage
                  id='ui.DetailsContainer.vatRate'
                  defaultMessage='TVA%'
                />
              </span>
            )}
            {columns.includes(BillingColumns.vat) && (
              <span className={clsx(s.vat, s.columnTitle)}>
                <FormattedMessage
                  id='ui.DetailsContainer.vatAmount'
                  defaultMessage='TVA€'
                />
              </span>
            )}
            {columns.includes(BillingColumns.unitTTC) && (
              <span className={clsx(s.price, s.columnTitle)}>
                <FormattedMessage
                  id='ui.DetailsContainer.priceTTC'
                  defaultMessage='PRIX TTC'
                />
              </span>
            )}
            {columns.includes(BillingColumns.totalTTC) && (
              <span className={clsx(s.price, s.columnTitle)}>
                <FormattedMessage
                  id='ui.DetailsContainer.totalTTC'
                  defaultMessage='TOTAL TTC'
                />
              </span>
            )}
          </div>
        </div>
      )}
      {children}
    </div>
  )
}

export default DetailsContainer
